import store from '@/store/store'
import { loading } from '@/prototypes/u/loading'

export function afterEach (app) {
  store.dispatch('removePageChanges')
  if (!app.meta.noHideLoading && store.state.helper.requestStatus.length === 0) {
    // Remove initial loading
    loading.hide()
  }
  window.history.replaceState({
    // ...history.state,
    newContent: true
  }, '')
  if (localStorage.getItem('newContent')) {
    setTimeout(() => {
      window.history.replaceState({
        // ...history.state,
        newContent: true
      }, '')
    }, 1)
    localStorage.removeItem('newContent')
  }
}
